export enum OverheadWireIssueQuestionValue {
	Down = 'Down',
	WithinReach = 'Within reach',
	Peeling = 'Peeling',
	HangingLowNotWithinReach = 'Low',
	// TODO: should this be considered like down or within reach?
	Exposed = 'Exposed',
}
